// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1323":"css/app.6846","1906":"css/admin-app.6846"}[chunkId] + ".css";
};